export const DEATH_MAX_AGE = 70;
export const DEATH_END_AGE = 89;
export const AKA_GROUP_LIFE_INSURED_DEATH_MAX_AGE = 70;
export const AKA_GROUP_LIFE_INSURED_DEATH_END_AGE = 70;
